/**
 * Notification store — polls unread count, manages notification list.
 */

import { api } from '$shared/api';
import { isLoggedIn } from '$lib/auth.svelte';

let _unreadCount = $state(0);
let _pollTimer: ReturnType<typeof setInterval> | null = null;

export function getUnreadCount(): number {
  return _unreadCount;
}

export async function fetchUnreadCount(): Promise<void> {
  if (!isLoggedIn()) return;
  try {
    const data = await api.get<{ count: number }>('/notifications/unread-count');
    _unreadCount = data.count;
  } catch {
    // Silently fail — non-critical
  }
}

export function startPolling(intervalMs = 60_000): void {
  stopPolling();
  fetchUnreadCount();
  _pollTimer = setInterval(fetchUnreadCount, intervalMs);
}

export function stopPolling(): void {
  if (_pollTimer) {
    clearInterval(_pollTimer);
    _pollTimer = null;
  }
}

export async function markAllRead(): Promise<void> {
  await api.post('/notifications/mark-all-read');
  _unreadCount = 0;
}

export async function markRead(id: number): Promise<void> {
  await api.post(`/notifications/${id}/mark-read`);
  _unreadCount = Math.max(0, _unreadCount - 1);
}

/** Increment unread count from real-time socket events (no API call needed). */
export function incrementUnread(): void {
  _unreadCount++;
}
